export default {
    inserted: function (el) {
        el.addEventListener('click', function(e) {
            e.preventDefault();
            this.classList.toggle('active');

            const isPressed = this.getAttribute('aria-pressed') === 'true';
            this.setAttribute('aria-pressed', !isPressed);
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/toggle-credit-image.js